import React from 'react'

import SearchResultsPage from './search-results-page'

export default function App() {
  return <SearchResultsPage />
}
